import _ from 'lodash';
import { createReducer, on } from '@ngrx/store';
import * as SurveyActions from './survey.actions';

export const surveyFeatureKey = 'survey';

export interface State {
  show?:null,
  record?:null
}


export const initialState: State = {
  show:null,
  record:null
};

export const reducer = createReducer(
  initialState,
  on(SurveyActions.loadSurvey, state => state),

  on(SurveyActions.loadSurveySuccess, (state, { data: { show }}) => {
    return {
      ...state,
      show
    }
  }),
  on(SurveyActions.loadRecord, state => state),

  on(SurveyActions.loadRecordSuccess, (state, action) => {
    return {
      ...state,
    }
  }),

  on(SurveyActions.resetSurvey, (state, action) => {
    return {
      ...state,
      show: null,
      record: null
    }
  })

);

